import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
	fetchShowcasesDispatch, fetchCategoriesDispatch, fetchBadgesDispatch,
	handleSelectedCategoryDispatch, handleSelectedBadgeDispatch, handleSearchDispatch, changeNumberDispatch,
	fetchDisclaimerDispatch, setPageNumberDispatch
} from '../actions';
import Pagination from './pagination';

global.searchChangeNumber = 0;
global.showcaseFetchingResults = false;

class MemberShowcase extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			ready: false
		};
	}

	loadData() {
		this.setState( {
           ready: true
        } );
	}

	componentWillMount() {
		this.loadData();
		this.props.fetchCategoriesDispatch();
		this.props.fetchDisclaimerDispatch();
		this.props.fetchShowcasesDispatch( [], [], '' );
		this.props.fetchBadgesDispatch();
	}

	componentWillUpdate( newProps ) {
		let prevChange    = this.props.changeNumber,
		    updatedChange = newProps.changeNumber;

		if ( this.props.searchTerm !== newProps.searchTerm || updatedChange > prevChange || this.props.selectedBadge !== newProps.selectedBadge || this.props.pagination.perPage !== newProps.pagination.perPage || this.props.pagination.pageNum !== newProps.pagination.pageNum ) {
			global.showcaseFetchingResults = true;

			this.props.fetchShowcasesDispatch( newProps.selectedCategory, newProps.selectedBadge, newProps.searchTerm, newProps.pagination.perPage, newProps.pagination.pageNum );
		}

		if ( updatedChange > prevChange ) {
			this.props.setPageNumberDispatch( 1 );
		}
	}

	componentDidUpdate( prevProps ) {
		//implement loading for search term only bc that's slower...
		if ( this.props.searchTerm ) {
			global.showcaseFetchingResults = false;
		}
	}

	handleSelectedCategory( event ) {
		global.searchChangeNumber = global.searchChangeNumber + 1;

		this.props.changeNumberDispatch( global.searchChangeNumber );
		this.props.handleSelectedCategoryDispatch( event.target.getAttribute( 'data-cat' ) );
	}

	handleBadgeFilter( event ) {
		global.searchChangeNumber = global.searchChangeNumber + 1;

		this.props.changeNumberDispatch( global.searchChangeNumber );
		this.props.handleSelectedBadgeDispatch( event.target.value );
	}

	handleSearch( event ) {
		global.searchChangeNumber = global.searchChangeNumber + 1;

		this.props.changeNumberDispatch( global.searchChangeNumber );
		this.props.handleSearchDispatch( event.target.value );
	}

	handleSubmit( event ) {
		event.preventDefault();
	}

	clearFilters( event ) {
		event.preventDefault();
		this.props.handleSearchDispatch( '' );
		this.clearBadge( );
	}

	clearBadge( ) {
		this.props.handleSelectedBadgeDispatch( '' );
		document.getElementById( 'showcase-badge-filter' ).selectedIndex = 0;
	}

	getCategory( selectedCategories, category ) {
		let cat_id = category.id.toString();

		return (
			<button type="button" className={ `btn btn-lg ${selectedCategories.includes( cat_id )
				? 'active'
				: ''} ` } id={ `btn-${ category.slug }` } data-cat={ category.id } onClick={ this.handleSelectedCategory.bind( this ) } dangerouslySetInnerHTML={ { __html: category.name } } />
		);
	}

	getBadgeOption( badges ) {
		const options = [];

		for ( const [key, value] of Object.entries(badges) ) {
			options.push(
				<option value={`${key}`}>
					{`${value}`}
				</option>
			);
		}

		return options;
	}

	getShowcase( showcase ) {

		return (
				<article className="showcase-listing col-md-4" data-key={showcase.id}>
					<h3 className="entry-title">
						<a href={showcase.link} dangerouslySetInnerHTML={{__html: showcase.title.rendered}}/>
					</h3>
				</article>
			);
	}

	showCasesConditional( showcases ) {
		if ( showcases.length === 0 && !global.showcaseFetchingResults ) {
			return (
				<p className="empty-showcase-text">No results found...</p>
			);
		} else if ( showcases.length === 0 && global.showcaseFetchingResults ) {
			return (
				<p className="empty-showcase-text">Fetching results...</p>
			);
		}

		this.totalCount = showcases.length;

		if ( parseInt( this.props.pageCount ) ) {
			let start = (this.props.pageNum - 1
			            ) * this.props.pageCount; // Zero-based index at which to begin extraction.
			let end = (this.props.pageNum * this.props.pageCount
			); // Zero-based index before which to end extraction. slice extracts up to but not including end.
			showcases = showcases.slice( start, end );
		}

		return (
			<div className="showcase-listing-wrapper">
				{ showcases.map( showcase => this.getShowcase( showcase ) ) }
			</div>
		);

	}

	render() {
		let categories = this.props.categories,
		    badges     = this.props.badges,
		    showcases  = this.props.showcases,
		    searchTerm = this.props.searchTerm;

		return (
			<div id="search-results">
				<div id="showcase-category-filters" className="btn-group filter-wrapper filter-category" role="group" aria-label="Category Filter">
					{ categories.map( category => this.getCategory( this.props.selectedCategory, category ) ) }
				</div>
				<form className="inner-page-search form-inline sorting-bar"
				      role="search"
				      onSubmit={ this.handleSubmit.bind( this ) }
				      aria-label="Member Showcase Search Form" method="get">
					<div className="row">
						<div className="form-group-keyword form-group col-xs-12 col-md-4">
							<label htmlFor="showcase-keyword-filter" className="sr-only">Keyword Filter</label>
							<input type="search" id="showcase-keyword-filter" className="form-control" placeholder="Find Company" value={ searchTerm } onChange={ this.handleSearch.bind( this ) } />
						</div>
						<div className="form-group col-xs-12 col-md-3">
							<label class="sr-only" htmlFor="showcase-badge-filter">Filter by badge</label>
							<select className="form-control" id="showcase-badge-filter" onChange={ this.handleBadgeFilter.bind( this ) } >
								<option name="" value="">All ISDA Recognition Badges</option>
								{ this.getBadgeOption( badges ) }
							</select>
						</div>
						<div className="form-group-clear col-xs-12 col-md-2 nopadding">
							<button type="button" className="btn-clear-inner-search" name="Clear all search filters" onClick={ this.clearFilters.bind( this ) }>
								<span className="glyphicon glyphicon-remove" aria-hidden="true"></span>
								Clear
							</button>
						</div>
					</div>
				</form>

				{ this.showCasesConditional( showcases ) }

				<Pagination />
			</div>
		);
	}
}

function mapStateToProps( { showcases, categories, selectedCategory, badges, selectedBadge, searchTerm, changeNumber, disclaimer, pagination } ) {
	return {
		showcases,
		categories,
		selectedCategory,
		badges,
		selectedBadge,
		searchTerm,
		changeNumber,
		disclaimer,
		pagination
	};
}

export default connect( mapStateToProps, {
	fetchShowcasesDispatch,
	fetchCategoriesDispatch,
	handleSelectedCategoryDispatch,
	fetchBadgesDispatch,
	handleSelectedBadgeDispatch,
	handleSearchDispatch,
	changeNumberDispatch,
	fetchDisclaimerDispatch,
	setPageNumberDispatch
} )( MemberShowcase );